import i18n from '../../i18n';

import {
  bikeTypesSelector
} from '../app';


export default bikeTypeSelector => {
  if (typeof bikeTypeSelector !== 'function') {
    throw new Error('bikeTypeSelector should be a function');
  }

  return state => {
    const bikeTypeId = bikeTypeSelector(state);

    if (bikeTypeId == null) {
      return;
    }

    const bikeTypes = bikeTypesSelector(state);

    if (!bikeTypes) {
      return;
    }

    const bikeType = bikeTypes.find(({ id }) => id === bikeTypeId);

    if (!bikeType) {
      return;
    }

    return i18n.t(bikeType.name, {ns: 'bikeTypes'});
  };
};



// WEBPACK FOOTER //
// ./src/selectors/makers/makeBikeTypeNameSelector.js